// Coincidencia de texto insensible a acentos y mayúsculas, por palabras.
// Misma semántica que el buscador del servidor (searchOr): cada palabra de la
// consulta debe aparecer en el texto; "andres espinosa" cruza nombre y apellido.

/** Quita acentos y pasa a minúscula. "Público" → "publico". */
export function deaccent(s: string): string {
  return s.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
}

/** ¿El texto contiene TODAS las palabras de la consulta (sin importar acentos)? */
export function matchesQuery(haystack: string, query: string): boolean {
  const q = deaccent(query).trim();
  if (!q) return true;
  const hay = deaccent(haystack);
  return q.split(/\s+/).every((tok) => hay.includes(tok));
}
